// modules/clientes/context/ClienteContext.jsx
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import * as clienteService from "../services/clienteService";

const ClienteContext = createContext(null);

const FILTROS_INICIAL = {
  buscar      : "",
  estado      : "",
  departamento: "",
  cod_servicio: "",
  cod_usuario : "",
  page        : 1,
  pageSize    : 50,
};

export const ClienteProvider = ({ children }) => {
  const [clientes,  setClientes]  = useState([]);
  const [total,     setTotal]     = useState(0);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);
  const [filtros,   setFiltros]   = useState(FILTROS_INICIAL);
  const [catalogos, setCatalogos] = useState({ servicios: [], usuarios: [] });

  // ── Cargar catálogos una sola vez ─────────────────────────
  useEffect(() => {
    const cargarCatalogos = async () => {
      try {
        const { data } = await clienteService.getCatalogos();
        setCatalogos(data || { servicios: [], usuarios: [] });
      } catch {
        // no bloquea la carga principal
      }
    };
    cargarCatalogos();
  }, []);

  // ── Cargar clientes ───────────────────────────────────────
  const fetchClientes = useCallback(async (params) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await clienteService.getAll(params);
      setClientes(Array.isArray(data?.rows) ? data.rows : []);
      setTotal(data?.total || 0);
    } catch (err) {
      setError(err?.response?.data?.message || "Error al cargar los clientes");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchClientes(filtros); }, [fetchClientes, filtros]);

  const setFiltro = (nuevo) => {
    setFiltros((prev) => ({ ...prev, ...nuevo, page: 1 }));
  };

  const setPage = (page) => {
    setFiltros((prev) => ({ ...prev, page }));
  };

  const resetFiltros = () => setFiltros(FILTROS_INICIAL);

  const refetch = () => fetchClientes(filtros);

  return (
    <ClienteContext.Provider value={{
      clientes, total, loading, error,
      filtros, catalogos,
      setFiltro, setPage, resetFiltros, refetch,
    }}>
      {children}
    </ClienteContext.Provider>
  );
};

export const useClientes = () => {
  const ctx = useContext(ClienteContext);
  if (!ctx) throw new Error("useClientes debe usarse dentro de ClienteProvider");
  return ctx;
};
